module.exports = __webpack_public_path__ + "img/bakery_bodyimage01.cafbedb5.jpg";